module.exports = __webpack_public_path__ + "img/public/SiteIcons/plus.svg?f9e3d6d8";